import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-purchase-order',
    templateUrl: './purchase-order.component.html',
    styleUrls: ['./purchase-order.component.scss'],
    standalone: false
})
export class PurchaseOrderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
